import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Splash from './views/Splash.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/splash',
      name: 'splash',
      meta: {layout: 'default'},
      component: Splash
    },
    {
      path: '/',
      name: 'home',
      meta: {layout: 'default'},
      component: Home
    },
    {
      path: '/welcome',
      name: 'welcome',
      meta: {layout: 'blank'},
      component: () => import(/* webpackChunkName: "about" */ './views/Welcome.vue')
    },
    {
      path: '/login',
      name: 'login',
      meta: {layout: 'blank'},
      component: () => import(/* webpackChunkName: "about" */ './views/Login.vue')
    },
    {
      path: '/forgot',
      name: 'forgot',
      meta: {layout: 'blank'},
      component: () => import(/* webpackChunkName: "about" */ './views/Forgot.vue')
    },
    {
      path: '/register',
      name: 'register',
      meta: {layout: 'blank'},
      component: () => import(/* webpackChunkName: "about" */ './views/Register.vue')
    },
    {
      path: '/select-challenge',
      name: 'select-challenge',
      meta: {layout: 'blank'},
      component: () => import(/* webpackChunkName: "about" */ './views/SelectChallenge.vue')
    },
    {
      path: '/my-profile',
      name: 'my-profile',
      meta: {layout: 'default'},
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Profile.vue')
    }
    ,
    {
      path: '/my-data/:section?',
      name: 'my-data',
      meta: {layout: 'default'},
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Data.vue')
    },
    {
      path: '/nutrition',
      name: 'nutrition',
      meta: {layout: 'default'},
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Nutrition.vue')
    },
    {
      path: '/nutrition/shopping-list/:week',
      name: 'nutrition-shopping-list',
      meta: {layout: 'default'},
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/NutritionShopping.vue')
    },
    {
      path: '/advice',
      name: 'advice',
      meta: {layout: 'default'},
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Advice.vue')
    },
    {
      path: '/privacy',
      name: 'privacy',
      meta: {layout: 'default'},
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Privacy.vue')
    },
    {
      path: '/advice/:slug',
      name: 'advice-article',
      meta: {layout: 'default'},
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/AdviceArticle.vue')
    },
    {
      path: '/recipe/:slug/:global_region_id?',
      name: 'recipe',
      meta: {layout: 'default'},
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Recipe.vue')
    },
    {
      path: '/messages/:route?',
      name: 'messages',
      meta: {layout: 'default'},
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Messages.vue')
    },
    {
      path: '/tsandcs',
      name: 'tsandcs',
      meta: {layout: 'blank-no-logo'},
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/TsAndCs.vue')
    },
    {
      path: '/view-tsandcs',
      name: 'view-tsandcs',
      meta: {layout: 'blank-no-logo'},
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/ViewTsAndCs.vue')
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})
